import { AxiosError } from 'axios';

import { FRANCHISEE_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { PaginatedFranchisees } from '@/types/franchisee.type';
import { ApiResponse } from '@/types/response.type';

export interface GetAllFranchiseesParams {
  page?: number;
  limit?: number;
}

const getAllFranchisees = async (
  params: GetAllFranchiseesParams = {}
): Promise<ApiResponse<PaginatedFranchisees>> => {
  try {
    const response = await apiManager.get(`${FRANCHISEE_API_URL}`, {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 10,
      },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getAllFranchisees;
